<div class="damage-card-widget" data-component="damage-analytics-widget">
  <div class="title-dropdown-row">
    <app-title-field
      [title]="'Damage Analytics'"
      [icon]="'analytics'"
      [iconUrl]="''"
      [showLink]="true"
      (click)="navigateToDamageAnalytics()"
      class="damage-title-field"
    >
    </app-title-field>
    <div class="dropdown-group parent-dropdown-width">
      <app-dropdown
        [options]="locationOptions"
        [displayKey]="'label'"
        [valueKey]="'value'"
        [label]="'Location'"
        [(ngModel)]="selectedLocation"
        (dropdownChange)="onLocationChange($event)"
      >
      </app-dropdown>
      <div>
      <app-dropdown
        [label]="'Select Month'"
        [options]="monthOptions"
        [(ngModel)]="selectedMonthValue"
        [valueKey]="'value'"
        [displayKey]="'label'"
        (dropdownChange)="handleMonthChange($event)"
        [preSelectedValue]="selectedMonth"
      >
      </app-dropdown>
      </div>

    </div>
  </div>

  <div *ngIf="isLoading" class="card-loading-overlay">
    <div class="card-spinner">
      <div class="spinner"></div>
      <span class="loading-text">Loading...</span>
    </div>
  </div>

  <div class="chart-and-summary_damage">
    <div *ngIf="!isLoading && isChartReady; else noDataTemplate" class="mini-chart-container damage-analytics-chart">
      <app-chart
        [data]="chartData"
        [type]="chartType"
        [labelKey]="chartLabelKey"
        [valueKey]="chartValueKey"
        [applyColorMap]="false"
        [height]="250"
        [width]="250"
        ariaLabel="Inventory distribution by item"
      >
      </app-chart>

      <div class="custom-legend" *ngIf="legendItems && legendItems.length > 0";>
        <div class="summary-header">
          <span class="col-asset">Assets</span>
          <span class="col-number">Number</span>
          <span class="col-cost">Total Cost</span>
        </div>
        <div class="legend-item" *ngFor="let item of legendItems">
          <div class="legend-header">
            <span
              class="legend-box"
              [style.backgroundColor]="item.color"
            ></span>
            <span class="legend-label">{{ item.label }}</span>
            <span class="legend-value">{{ item.value }}</span>
            <span class="legend-cost">{{ formatCurrency(item.totalCost) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container *ngIf="isDataLoaded">
          <h3 class="empty-state-title">{{ errorMsg }}</h3>
        </ng-container>
        <img
          [src]="imageSrc"
          alt="No records illustration"
          class="empty-state-image"
        />
      </div>
    </section>
  </ng-template>
</div>
